import { useState } from "react";
import { Share2, Copy, Check, MessageCircle, Mail } from "lucide-react";

export default function TellAFriend() {
  const [copied, setCopied] = useState(false);
  const shareUrl =
    typeof window !== "undefined" ? window.location.href : "";
  const shareText =
    "Check out The Babysitting Club — six awesome 10–11 year olds ready to babysit!";

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "The Babysitting Club",
          text: shareText,
          url: shareUrl,
        });
        return;
      } catch (e) {
        // user cancelled or share unsupported — fall back to copy
      }
    }
    handleCopy();
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(`${shareText} ${shareUrl}`);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      // ignore
    }
  };

  return (
    <section
      id="share"
      data-testid="share-section"
      className="relative py-20 px-4"
    >
      <div className="max-w-4xl mx-auto">
        <div
          data-testid="share-card"
          className="relative bg-[#FF6B9E] border-4 border-gray-900 rounded-3xl p-8 sm:p-12 shadow-pop -rotate-1 text-center overflow-hidden"
        >
          {/* Corner stickers */}
          <div className="absolute -top-4 -left-4 w-16 h-16 bg-[#FFD166] border-4 border-gray-900 rounded-full flex items-center justify-center rotate-12 font-display text-lg text-gray-900">
            !
          </div>
          <div className="absolute -bottom-4 -right-4 w-16 h-16 bg-[#38E5B6] border-4 border-gray-900 rounded-full flex items-center justify-center -rotate-12 font-display text-lg text-gray-900">
            ✦
          </div>

          <span className="font-hand text-3xl text-white">~ psst! ~</span>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl text-white mt-2 leading-tight">
            Know a parent who needs a sitter?
          </h2>
          <p className="mt-3 text-base sm:text-lg text-white/95 font-semibold max-w-xl mx-auto">
            Spread the word! Help us find more families to hang out with.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              data-testid="share-button"
              onClick={handleShare}
              className="group inline-flex items-center gap-2 bg-white text-gray-900 font-display text-lg px-6 py-4 rounded-full border-4 border-gray-900 shadow-pop-sm btn-pop"
            >
              <Share2 size={20} />
              Tell a Friend
            </button>

            <button
              data-testid="share-copy-button"
              onClick={handleCopy}
              className="inline-flex items-center gap-2 bg-[#FFD166] text-gray-900 font-display text-lg px-6 py-4 rounded-full border-4 border-gray-900 shadow-pop-sm btn-pop"
            >
              {copied ? (
                <>
                  <Check size={20} /> Copied!
                </>
              ) : (
                <>
                  <Copy size={20} /> Copy Link
                </>
              )}
            </button>
          </div>

          {/* Quick share options */}
          <div className="mt-6 flex items-center justify-center gap-3 flex-wrap">
            <a
              data-testid="share-sms"
              href={`sms:?&body=${encodeURIComponent(`${shareText} ${shareUrl}`)}`}
              className="inline-flex items-center gap-1.5 bg-white/90 hover:bg-white text-gray-900 text-sm font-bold px-4 py-2 rounded-full border-2 border-gray-900 transition-colors"
            >
              <MessageCircle size={16} /> Text
            </a>
            <a
              data-testid="share-email"
              href={`mailto:?subject=${encodeURIComponent(
                "Check out The Babysitting Club!"
              )}&body=${encodeURIComponent(`${shareText}\n\n${shareUrl}`)}`}
              className="inline-flex items-center gap-1.5 bg-white/90 hover:bg-white text-gray-900 text-sm font-bold px-4 py-2 rounded-full border-2 border-gray-900 transition-colors"
            >
              <Mail size={16} /> Email
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
